import CreateBundleTemplate from './CreateBundleTemplate';

export default CreateBundleTemplate;
